'use strict';

var React = require('react'),
    onlyChild = require('react/lib/onlyChild'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { PropTypes } = require('react');

var OffsetMonitor = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    onOffsetTopChange: PropTypes.func
  },

  componentDidMount() {
    if (!this.props.onOffsetTopChange) {
      return;
    }

    window.addEventListener('scroll', this._updateOffsetTop);
    window.addEventListener('visibilitychange', this._updateOffsetTop);
    window.addEventListener('resize', this._updateOffsetTop);
    this._updateOffsetsInterval = setInterval(this._updateOffsetTop, 700);
    this._updateOffsetTop();
  },

  componentWillUnmount() {
    if (!this.props.onOffsetTopChange) {
      return;
    }

    window.removeEventListener('scroll', this._requestFrame);
    window.removeEventListener('visibilitychange', this._updateOffsetTop);
    window.removeEventListener('resize', this._updateOffsetTop);
    clearInterval(this._updateOffsetsInterval);
  },

  render() {
    return onlyChild(this.props.children);
  },

  _updateOffsetTop() {
    if (!this.isMounted()) {
      return;
    }

    var node = this.getDOMNode();
    if (!node) {
      return;
    }

    var offsetTop = node.offsetTop;
    if (offsetTop !== this._lastOffsetTop) {
      this._lastOffsetTop = offsetTop;
      this.props.onOffsetTopChange(offsetTop);
    }
  }
});

module.exports = OffsetMonitor;


/** WEBPACK FOOTER **
 ** ./atoms/OffsetMonitor.jsx
 **/